module.exports = __webpack_public_path__ + "static/media/footerL.5d1ad071.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/footerL.png
// module id = 792
// module chunks = 2